import React from "react";
import { Table } from "reactstrap";
import { formatDate } from "../../../../Utils/format-date.js";
import { addClassName } from "../../../../Utils/Add-ClassName.js";
import { calcPercentage } from "../../../../Utils/calculate-progress.js";
import Button from "../../../../Utils/Button/index";
import LayoutCard from "../../../Layout/Layout";
import MyReportsIcon from "../../../../../images/new-images/myreports.png";
import OpPopover from "../../../PopOver/Popover";
import info_black_24dp from "../../../../../images/info_black_24dp.png";
import Renderpopoverinnercontent from "../../../../Dashboard/My-assessments/popover-inner-content";
import "./Assessment-Table.css";
import completed from "../../../../../images/new-images/completed.png";
import { Link } from "react-router-dom";

const AssessmentTable = (props) => {
  
  const newFilteredData = [];
  const isAuthParticipant = localStorage.getItem("is_auth_participant");

  props.myReports.filter((filteredArray) => {
    if (filteredArray.assessment_status__status_name === "Report in review") {
      return newFilteredData.push(filteredArray);
    } else if (filteredArray.assessment_status__status_name === "Completed") {
      return newFilteredData.push(filteredArray);
    }
    return null;
  });

  return (
    <LayoutCard 
      headerIcon={MyReportsIcon} 
      headerText="Assessment Reports" 
      isExtra={true}
      handleYearSelect = {props.handleYearSelect}
      >
      <div className="my-reports">
        {newFilteredData.length == 0 ? (
          <h1 className="no-reports">There are no reports avaliable</h1>
        ) : (
          <Table>
            <thead>
              <tr>
                <th className="tableHeaders">Assessment</th>
                <th className="tableHeaders">Date</th>
                <th className="tableHeaders">Status</th>
                <th className="tableHeaders">Action</th>
              </tr>
            </thead>
            <tbody>
              {newFilteredData.map((assessment, index) => {
                return (
                  <React.Fragment key={index}>
                    <tr key={index}>
                      <td>
                        <div className="assessmentType">
                          <img
                            className="assessmentIcon"
                            src={
                              localStorage.getItem("baseLink") +
                              `/media/` +
                              assessment.instrument__instrument_image
                            }
                          />
                          <div className="assessmentName">
                            {assessment.instrument__dashboard_header_text}
                          </div>
                          <OpPopover
                            positions={newFilteredData.length < 2 ? ["bottom"] : ["right"]}
                            align={"center"}
                            targtElement={
                              <img className="infoIcon" src={info_black_24dp} />
                            }
                            isOpen={
                              props.isPopOverOpenAssessmentId === assessment.id
                            }
                            setOpen={(bool) => {
                              props.handleAssessmentPopOver(
                                bool ? assessment.id : false
                              );
                            }}
                          >
                            <Renderpopoverinnercontent
                              handleClosePopOver={props.handleClosePopOver}
                              assessmentheading={
                                assessment.instrument__dashboard_header_text
                              }
                              assesmentdescription={
                                assessment.instrument__dashboard_header_description
                              }
                            />
                          </OpPopover>
                        </div>
                        <div className="userName">
                          {assessment.participant__full_name}'s
                          <span style={{ marginLeft: '5px' }}>{assessment.instrument__instrument_name}</span>
                        </div>
                      </td>
                      <td>
                        <div className="Date">
                          {formatDate(assessment.expiry_date)}
                        </div>
                      </td>
                      <td>
                        {assessment.assessment_status__status_name ===
                          "In progress" ? (
                          <div
                            style={{ display: "flex" }}
                            className={
                              "assessment-status-text " +
                              addClassName(
                                assessment.assessment_status__status_name
                              )
                            }
                          >
                            {assessment.assessment_status__status_name}
                            {calcPercentage(
                              assessment.assessment_number_count,
                              assessment.assessment_completed_count
                            )}
                          </div>
                        ) : assessment.assessment_status__status_name ===
                          "Report in review" ? (
                          <div
                            className={
                              "assessment-status-text " +
                              addClassName(
                                assessment.assessment_status__status_name
                              )
                            }
                          >
                            Completed
                            <img src={completed} alt="Completed Image" />
                          </div>
                        ) : (
                          <div
                            className={
                              "assessment-status-text " +
                              addClassName(
                                assessment.assessment_status__status_name
                              )
                            }
                          >
                            {assessment.assessment_status__status_name}
                          </div>
                        )}
                      </td>
                      {isAuthParticipant === 'true' ? (
                        <td>
                          {assessment.enable_report ? (
                            <Button type="disabled report">VIEW REPORT</Button>
                          ) : (
                            <Button type="disabled report">VIEW REPORT</Button>
                          )}
                        </td>
                      ) : (
                        <td>
                          {assessment.enable_report ? (
                            <Link
                              to={{
                                pathname: `/new/app/reportdownload/${assessment.id}/${assessment.participant__id}`,
                              }}
                            >
                              <Button type="submit">VIEW REPORT</Button>
                            </Link>
                          ) : (
                            <Button type="disabled report">VIEW REPORT</Button>
                          )}
                        </td>
                      )}
                    </tr>
                  </React.Fragment>
                );
              })}
            </tbody>
          </Table>
        )}
      </div>
    </LayoutCard>
  );
};

export default AssessmentTable;



// WEBPACK FOOTER //
// ./src/new/Components/Reports/My-Reports/Assessment-Table/Assessment-Table.jsx